import type { Validator } from './types';

export function composeValidators<TValue>(...validators: Validator<TValue>[]): Validator<TValue> {
    return (value?: TValue) =>
        validators.reduce(
            (error: string | undefined, validator) => error || validator(value),
            undefined,
        );
}
